export function getBucketEnv(tenant: string) {
  const bucketEnv =
    window.location.host === 'dev.quipli.com' || window.location.host.includes('localhost')
      ? 'dev'
      : window.location.host === 'qa.quipli.com'
      ? 'qa'
      : window.location.host === 'integration.quipli.com'
      ? 'integration'
      : window.location.host === 'beta.quipli.com'
      ? 'beta'
      : tenant === 'gameready'
      ? 'hipaa'
      : 'prod';
  return bucketEnv;
}
